import { useLocation } from 'react-router';
import { BaseRoutes } from './BaseRoutes';
import { ModalProvider } from './context/Modal/ModalProvider';
import { ExportUserProvider } from './context/User/ExportUserProvider';
import { UserContextProvider } from './context/User/UserProvider';

export const AppContent = () => {
  const location = useLocation();
  const isExportRoute = location.pathname.includes('/projects/export');

  if (isExportRoute) {
    return (
      <ExportUserProvider>
        <ModalProvider>
          <BaseRoutes />
        </ModalProvider>
      </ExportUserProvider>
    );
  }

  return (
    <UserContextProvider>
      <ModalProvider>
        <BaseRoutes />
      </ModalProvider>
    </UserContextProvider>
  );
};
